import { Paper, Stack } from '@mantine/core'
import { BulkAssessRow } from '../../teacherAssessmentDrawer/components/BulkAssessRow'
import { FinalCurriculumRow } from './FinalCurriculumRow'
import { FinalStudentRow } from './FinalStudentRow'
import type { FinalAssessmentItem, FinalDrawerStudent } from '../types'

interface FinalAssessmentItemCardProps {
  item: FinalAssessmentItem
  visibleStudents: FinalDrawerStudent[]
  onStudentScoreChange: (studentId: string, score: number) => void
  onBulkScore: (score: number) => void
  onViewLessonsAssessments: (studentId: string) => void
}

/**
 * Card per curriculum item: green/blue left accent border, the curriculum
 * header, an optional bulk-assess row (when more than one student is visible),
 * and one FinalStudentRow per visible student. Reuses the lesson drawer's
 * BulkAssessRow with `showDeliverableColumn={false}` so the bulk picker lines
 * up over the per-student Teacher Assessment column.
 */
export function FinalAssessmentItemCard({
  item,
  visibleStudents,
  onStudentScoreChange,
  onBulkScore,
  onViewLessonsAssessments,
}: FinalAssessmentItemCardProps) {
  const color = item.curriculumKind === 'content' ? 'green' : 'blue'

  return (
    <Paper
      withBorder
      radius="md"
      p="md"
      style={{ borderLeftColor: `var(--mantine-color-${color}-6)`, borderLeftWidth: 4 }}
    >
      <Stack spacing="md">
        <FinalCurriculumRow item={item} />

        {visibleStudents.length > 1 && (
          <BulkAssessRow onChange={onBulkScore} showDeliverableColumn={false} color={color} rubrics={item.rubrics} />
        )}

        <Stack spacing="md">
          {visibleStudents.map(student => (
            <FinalStudentRow
              key={`${item.lv4ItemId}:${student.id}`}
              item={item}
              student={student}
              onScoreChange={score => onStudentScoreChange(student.id, score)}
              onViewLessonsAssessments={() => onViewLessonsAssessments(student.id)}
            />
          ))}
        </Stack>
      </Stack>
    </Paper>
  )
}
